<template>
  <el-dialog
    v-if="model"
    :title="(model.id > 0 ? '编辑' : '发布') + '促销'"
    :visible.sync="visible"
    width="560px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
    @open="opened()"
  >
    <el-form
      v-if="model"
      ref="form"
      label-width="90px"
      :model="model"
      :rules="formRules"
    >
      <el-form-item label="商品件号" prop="commodity_id">
        <commodity-select
          :val="model.commodity_id"
          @change="commodityIDChange"
          :departmentLimit="true"
        ></commodity-select>
      </el-form-item>
      <!-- <el-form-item label="商品描述" prop="material_desc">
        <el-input placeholder="请输入描述" v-model="model.material_desc">
        </el-input>
      </el-form-item> -->
      <!-- <el-form-item label="件号" prop="material">
        <el-input placeholder="" v-model="model.material"> </el-input>
      </el-form-item> -->
      <el-form-item label="原价" v-if="model.commodity_id">
        <el-input placeholder="" v-model="model.price" disabled> </el-input>
      </el-form-item>
      <el-form-item label="促销价" prop="promotion_price">
        <el-input placeholder="" v-model="model.promotion_price"> </el-input>
      </el-form-item>
      <el-form-item label="促销时间" prop="dates">
        <el-date-picker
          class="date-range"
          v-model="dates"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOption"
        >
        </el-date-picker>
        <div class="el-form-item__tips">促销将按照设定的时间自动开始和结束</div>
      </el-form-item>
      <el-form-item label="促销总量" prop="total_quantity">
        <el-input
          placeholder="本次促销活动的产品总量"
          v-model="model.total_quantity"
        >
        </el-input>
        <span class="el-form-item__tips">0表示不限制促销总量</span>
      </el-form-item>
      <!-- <el-form-item label="限购数量" prop="buy_quantity">
        <el-input placeholder="个体购买数量限制" v-model="model.buy_quantity">
        </el-input>
        <span class="el-form-item__tips">0表示不显示购买数量</span>
      </el-form-item> -->
      <!-- <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :rows="2"
          placeholder=""
          v-model="model.remark"
        >
        </el-input>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import CommoditySelect from '@/components/select/commodity_select'
import {
  createProductPromotion,
  updateproductPromotion,
  commodityList,
} from '../../service/getData'
import { clone } from '../../util'

export default {
  components: {
    CommoditySelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    dates() {
      this.model.dates = this.dates
    },
  },
  data() {
    var priceChcek = (rule, value, callback) => {
      if (parseFloat(value) >= parseFloat(this.model.price)) {
        callback(new Error('促销价须小于原价'))
        return
      }
      callback()
    }
    return {
      visible: this.show,
      dates: [],
      formRules: {
        commodity_id: [{ required: true, message: '件号不能为空' }],
        // material_desc: [
        //   { required: true, message: '请输入促销产品描述', trigger: 'blur' },
        // ],
        // price: [{ required: true, message: '请输入原价', trigger: 'blur' }],
        promotion_price: [
          { required: true, message: '请输入促销价', trigger: 'blur' },
          { validator: priceChcek, trigger: 'blur' },
        ],
        dates: [
          { required: true, message: '请选择促销起止时间', trigger: 'blur' },
        ],
      },
      pickerOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      submiting: false,
    }
  },
  created() {},
  methods: {
    opened() {
      if (this.model.id > 0) {
        this.dates = this.model.dates
      } else {
        this.dates = []
      }
    },
    async commodityIDChange(e) {
      this.model.commodity_id = e
      let res = await commodityList({
        default_id: this.model.commodity_id,
        size: 20,
        page: 0,
      })
      if (res.code == 0) {
        let commodity = res.data.list[0]
        this.model.price = commodity.price
        this.model.material_desc = commodity.description
        this.model.material = commodity.part_number
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let data = clone(this.model)
          data.total_quantity = parseInt(data.total_quantity) || 0
          data.buy_quantity = parseInt(data.buy_quantity) || 0

          if (this.dates.length == 2) {
            data.start_date = new Date(
              this.dates[0] + ' 00:00:00'
            ).toISOString()
            data.end_date = new Date(this.dates[1] + ' 23:59:59').toISOString()
          }
          data.price = parseFloat(data.price) || 0
          data.promotion_price = parseFloat(data.promotion_price) || 0
          data.left_quantity = data.total_quantity
          delete data.dates
          if (data.id > 0) {
            let res = await updateproductPromotion(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await createProductPromotion(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
          this.submiting = false
        } else {
          this.submiting = false
        }
      })
    },
  },
}
</script>

<style scoped>
.date-range {
  width: 100%;
}
</style>